var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { attrs: { id: "vendors-allocated-order" } }, [
    _c("div", { staticClass: "container bg-light-grey mb-16" }, [
      _c("div", { staticClass: "table-header px-4" }, [
        _c("div", { staticClass: "nav" }, [
          _c(
            "button",
            {
              staticClass: "flex items-center",
              attrs: { onclick: "window.history.back();" }
            },
            [
              _c(
                "svg",
                { staticClass: "w-5", attrs: { viewBox: "0 0 448 512" } },
                [
                  _c("path", {
                    attrs: {
                      fill: "white",
                      d:
                        "M231.536 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L60.113 273H436c6.627 0 12-5.373 12-12v-10c0-6.627-5.373-12-12-12H60.113L238.607 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L3.515 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z"
                    }
                  })
                ]
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("h3", { staticClass: "mb-2" }, [
          _vm._v("Allocated Order #" + _vm._s(_vm.order.aoId))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content py-4" }, [
        _c("section", { staticClass: "shadow-sm p-4", attrs: { id: "info" } }, [
          _c("div", { staticClass: "md:grid md:grid-cols-3 md:gap-6" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "mt-5 md:mt-0 md:col-span-2" }, [
              _c("div", { staticClass: "shadow sm:rounded-md" }, [
                _c(
                  "div",
                  { staticClass: "px-4 py-5 bg-white sm:p-6 flex flex-col" },
                  [
                    _c("h2", { staticClass: "text-base text-black px-4" }, [
                      _vm._v("Order ID: "),
                      _c("span", {
                        staticClass: "text-green normal-case",
                        domProps: { innerHTML: _vm._s(_vm.order.reference) }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "status flex" }, [
                      _c(
                        "h2",
                        {
                          staticClass:
                            "text-base text-black px-4 whitespace-no-wrap"
                        },
                        [_vm._v("Order status:")]
                      ),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.orderStatus,
                              expression: "orderStatus"
                            }
                          ],
                          staticClass:
                            "h-10 w-1/3 form-select block pl-3 pr-10 py-2 text-base leading-6 border-gray-300 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5",
                          attrs: {
                            name: "status",
                            id: "status",
                            disabled: _vm.isDisabled
                          },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.orderStatus = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            }
                          }
                        },
                        _vm._l(_vm.statuses, function(status) {
                          return _c(
                            "option",
                            {
                              key: status.id,
                              domProps: { value: status.value }
                            },
                            [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(status.text) +
                                  "\n                    "
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "status flex py-2" }, [
                      _c(
                        "h2",
                        {
                          staticClass:
                            "text-base text-black px-4 whitespace-no-wrap"
                        },
                        [_vm._v("Allocation order status:")]
                      ),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.allocationOrderStatus,
                              expression: "allocationOrderStatus"
                            }
                          ],
                          staticClass:
                            "h-10 w-1/3 form-select block pl-3 pr-10 py-2 text-base leading-6 border-gray-300 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5",
                          attrs: {
                            name: "allocated-status",
                            id: "allocated-status",
                            disabled: _vm.isDisabled
                          },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.allocationOrderStatus = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            }
                          }
                        },
                        _vm._l(_vm.statuses, function(status) {
                          return _c(
                            "option",
                            {
                              key: status.id,
                              domProps: { value: status.value }
                            },
                            [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(status.text) +
                                  "\n                    "
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  ]
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "form",
          { attrs: { method: "post", "accept-charset": "UTF-8", action: "" } },
          [
            _c("input", {
              attrs: { type: "hidden", name: "CRAFT_CSRF_TOKEN" },
              domProps: { value: _vm.order.token }
            }),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "shadow-sm p-4", attrs: { id: "buyer" } },
              [
                _c("div", { staticClass: "md:grid md:grid-cols-3 md:gap-6" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-5 md:mt-0 md:col-span-2" }, [
                    _c("div", { staticClass: "shadow sm:rounded-md" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "px-4 py-5 bg-white sm:p-6 flex flex-wrap"
                        },
                        [
                          _c("div", { staticClass: "w-full p-2" }, [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "block text-sm font-medium leading-5 text-gray-700",
                                attrs: { for: "accountName" }
                              },
                              [_vm._v("Company Name")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "mt-1 relative rounded-md shadow-sm"
                              },
                              [
                                _c("input", {
                                  staticClass:
                                    "form-input block w-full sm:text-sm sm:leading-5",
                                  attrs: {
                                    type: "text",
                                    name: "accountName",
                                    required: "",
                                    disabled: ""
                                  },
                                  domProps: { value: _vm.order.billing.title }
                                })
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "w-5/12 p-2" }, [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "block text-sm font-medium leading-5 text-gray-700",
                                attrs: { for: "regionalDirector" }
                              },
                              [_vm._v("Regional Director")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "mt-1 relative rounded-md shadow-sm"
                              },
                              [
                                _c("p", {
                                  staticClass:
                                    "form-input block w-full sm:text-sm sm:leading-5 disabled",
                                  domProps: {
                                    innerHTML: _vm._s(_vm.regionalDirector)
                                  }
                                })
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "w-3/12 p-2" }, [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "block text-sm font-medium leading-5 text-gray-700",
                                attrs: { for: "createdOn" }
                              },
                              [_vm._v("Created On")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "mt-1 relative rounded-md shadow-sm"
                              },
                              [
                                _c("input", {
                                  staticClass:
                                    "form-input block w-full sm:text-sm sm:leading-5",
                                  attrs: {
                                    type: "text",
                                    name: "createdOn",
                                    disabled: ""
                                  },
                                  domProps: { value: _vm.order.orderDate }
                                })
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "w-3/12 p-2" }, [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "block text-sm font-medium leading-5 text-gray-700",
                                attrs: { for: "lastUpdated" }
                              },
                              [_vm._v("Last Updated On")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "mt-1 relative rounded-md shadow-sm"
                              },
                              [
                                _c("input", {
                                  staticClass:
                                    "form-input block w-full sm:text-sm sm:leading-5",
                                  attrs: {
                                    type: "text",
                                    name: "lastUpdated",
                                    disabled: ""
                                  },
                                  domProps: { value: _vm.order.orderDate }
                                })
                              ]
                            )
                          ])
                        ]
                      )
                    ])
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "shadow-sm p-4", attrs: { id: "shipping" } },
              [
                _c("div", { staticClass: "md:grid md:grid-cols-3 md:gap-6" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-5 md:mt-0 md:col-span-2" }, [
                    _c("div", { staticClass: "shadow sm:rounded-md" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "px-4 py-5 bg-white sm:p-6 flex flex-wrap"
                        },
                        [
                          _c("div", { staticClass: "w-full p-2" }, [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "block text-sm font-medium leading-5 text-gray-700",
                                attrs: { for: "shipToName" }
                              },
                              [_vm._v("Ship To Name")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "mt-1 relative rounded-md shadow-sm"
                              },
                              [
                                _c("input", {
                                  staticClass:
                                    "form-input block w-full sm:text-sm sm:leading-5",
                                  attrs: {
                                    type: "text",
                                    name: "shipToAddress",
                                    disabled: ""
                                  },
                                  domProps: { value: _vm.order.shipping.name }
                                })
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "w-2/3 p-2" }, [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "block text-sm font-medium leading-5 text-gray-700",
                                attrs: { for: "shipToAddress" }
                              },
                              [_vm._v("Ship To Address")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "mt-1 relative rounded-md shadow-sm"
                              },
                              [
                                _c("input", {
                                  staticClass:
                                    "form-input block w-full sm:text-sm sm:leading-5",
                                  attrs: {
                                    type: "text",
                                    name: "shipToAddress",
                                    disabled: ""
                                  },
                                  domProps: { value: _vm.shippingAddress }
                                })
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "w-1/3 p-2" }, [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "block text-sm font-medium leading-5 text-gray-700",
                                attrs: { for: "shipToCode" }
                              },
                              [_vm._v("Ship To Code")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "mt-1 relative rounded-md shadow-sm"
                              },
                              [
                                _c("input", {
                                  staticClass:
                                    "form-input block w-full sm:text-sm sm:leading-5",
                                  attrs: {
                                    type: "text",
                                    name: "shipToCode",
                                    disabled: ""
                                  },
                                  domProps: { value: _vm.order.shipping.id }
                                })
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "w-6/12 p-2" }, [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "block text-sm font-medium leading-5 text-gray-700",
                                attrs: { for: "bol" }
                              },
                              [_vm._v("Delivery Type")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "mt-1 relative rounded-md shadow-sm"
                              },
                              [
                                _c(
                                  "select",
                                  {
                                    staticClass:
                                      "form-input block w-full sm:text-sm sm:leading-5 sk-select",
                                    attrs: {
                                      name: "delivery_type",
                                      disabled: _vm.isDisabled
                                    },
                                    domProps: { value: _vm.ao.delivery_type },
                                    on: { change: _vm.inputValueChanged }
                                  },
                                  [
                                    _c("option", { attrs: { value: "1" } }, [
                                      _vm._v("FedEx")
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "2" } }, [
                                      _vm._v("CH Robinson")
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "3" } }, [
                                      _vm._v("Old Dominion")
                                    ])
                                  ]
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "w-6/12 p-2" }, [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "block text-sm font-medium leading-5 text-gray-700",
                                attrs: { for: "delivery_tracking_code" }
                              },
                              [_vm._v("Delivery Tracking Code")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "mt-1 relative rounded-md shadow-sm"
                              },
                              [
                                _c("input", {
                                  staticClass:
                                    "form-input block w-full sm:text-sm sm:leading-5",
                                  attrs: {
                                    type: "text",
                                    name: "delivery_tracking_code",
                                    disabled: _vm.isDisabled
                                  },
                                  domProps: {
                                    value: _vm.ao.delivery_tracking_code
                                  },
                                  on: { change: _vm.inputValueChanged }
                                })
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "w-6/12 p-2" }, [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "block text-sm font-medium leading-5 text-gray-700",
                                attrs: { for: "delivery_status" }
                              },
                              [_vm._v("Delivery status")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "mt-1 relative rounded-md shadow-sm"
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.delivery_status,
                                      expression: "delivery_status"
                                    }
                                  ],
                                  staticClass:
                                    "form-input block w-full sm:text-sm sm:leading-5",
                                  attrs: {
                                    type: "text",
                                    name: "delivery_status",
                                    required: "",
                                    disabled: ""
                                  },
                                  domProps: { value: _vm.delivery_status },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.delivery_status = $event.target.value
                                    }
                                  }
                                })
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "w-6/12 p-2 pl-6 align-items-end" },
                            [
                              _c("div", { staticClass: "relative" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "sk-btn-fix rounded-full flex items-center text-base text-white shadow-solid bg-green py-3 px-4 mt-4",
                                    attrs: {
                                      type: "submit",
                                      disabled: _vm.disableSyncBtn
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.syncBtnClick($event)
                                      }
                                    }
                                  },
                                  [_vm._v("Sync delivery status")]
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "w-1/2 p-2" }, [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "block text-sm font-medium leading-5 text-gray-700",
                                attrs: { for: "hrmsCode" }
                              },
                              [_vm._v("HRMS Ship To #")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "mt-1 relative rounded-md shadow-sm"
                              },
                              [
                                _c("input", {
                                  staticClass:
                                    "form-input block w-full sm:text-sm sm:leading-5",
                                  attrs: {
                                    type: "text",
                                    name: "hrmsCode",
                                    disabled: _vm.isDisabled
                                  },
                                  domProps: { value: _vm.ao.hrmsCode },
                                  on: { change: _vm.inputValueChanged }
                                })
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "w-1/2 p-2" }, [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "block text-sm font-medium leading-5 text-gray-700",
                                attrs: { for: "hrms_release_number" }
                              },
                              [_vm._v("HRMS Release #")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "mt-1 relative rounded-md shadow-sm"
                              },
                              [
                                _c("input", {
                                  staticClass:
                                    "form-input block w-full sm:text-sm sm:leading-5",
                                  attrs: {
                                    type: "text",
                                    name: "hrms_release_number",
                                    disabled: _vm.isDisabled
                                  },
                                  domProps: {
                                    value: _vm.ao.hrms_release_number
                                  },
                                  on: { change: _vm.inputValueChanged }
                                })
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "w-1/2 p-2" }, [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "block text-sm font-medium leading-5 text-gray-700",
                                attrs: { for: "qtyPallets" }
                              },
                              [_vm._v("Qty. Pallets")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "mt-1 relative rounded-md shadow-sm"
                              },
                              [
                                _c("input", {
                                  staticClass:
                                    "form-input block w-full sm:text-sm sm:leading-5",
                                  attrs: {
                                    type: "number",
                                    name: "qtyPallets",
                                    disabled: _vm.isDisabled
                                  },
                                  domProps: { value: _vm.ao.qtyPallets },
                                  on: { change: _vm.inputValueChanged }
                                })
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "w-1/2 p-2" }, [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "block text-sm font-medium leading-5 text-gray-700",
                                attrs: { for: "approximateWeightLoad" }
                              },
                              [_vm._v("Approximate Weight Load")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "mt-1 relative rounded-md shadow-sm"
                              },
                              [
                                _c("input", {
                                  staticClass:
                                    "form-input block w-full sm:text-sm sm:leading-5",
                                  attrs: {
                                    type: "number",
                                    name: "approximateWeightLoad",
                                    disabled: _vm.isDisabled
                                  },
                                  domProps: {
                                    value: _vm.ao.approximateWeightLoad
                                  },
                                  on: { change: _vm.inputValueChanged }
                                })
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "w-1/2 p-2" }, [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "block text-sm font-medium leading-5 text-gray-700",
                                attrs: { for: "transitDays" }
                              },
                              [_vm._v("Transit Days")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "mt-1 relative rounded-md shadow-sm"
                              },
                              [
                                _c("input", {
                                  staticClass:
                                    "form-input block w-full sm:text-sm sm:leading-5",
                                  attrs: {
                                    type: "text",
                                    name: "transitDays",
                                    disabled: _vm.isDisabled
                                  },
                                  domProps: {
                                    value: _vm.order.shipping.transitDays
                                  },
                                  on: { change: _vm.inputValueChanged }
                                })
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "w-1/2 p-2" }, [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "block text-sm font-medium leading-5 text-gray-700",
                                attrs: { for: "aniticipatedPU" }
                              },
                              [_vm._v("Anticipated Pick-up Date")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "mt-1 relative rounded-md shadow-sm"
                              },
                              [
                                _c("date-picker", {
                                  attrs: {
                                    "value-type": "YYYY-MM-DD",
                                    format: "MM/DD/YYYY",
                                    name: "aniticipatedPU",
                                    disabled: _vm.isDisabled
                                  },
                                  model: {
                                    value: _vm.ao.aniticipatedPU,
                                    callback: function($$v) {
                                      _vm.$set(_vm.ao, "aniticipatedPU", $$v)
                                    },
                                    expression: "ao.aniticipatedPU"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "w-1/2 p-2" }, [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "block text-sm font-medium leading-5 text-gray-700",
                                attrs: { for: "actualPU" }
                              },
                              [_vm._v("Actual Pick-up Date")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "mt-1 relative rounded-md shadow-sm"
                              },
                              [
                                _c("date-picker", {
                                  attrs: {
                                    "value-type": "YYYY-MM-DD",
                                    format: "MM/DD/YYYY",
                                    name: "actualPU",
                                    disabled: _vm.isDisabled
                                  },
                                  model: {
                                    value: _vm.ao.actualPU,
                                    callback: function($$v) {
                                      _vm.$set(_vm.ao, "actualPU", $$v)
                                    },
                                    expression: "ao.actualPU"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "w-1/2 p-2" }, [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "block text-sm font-medium leading-5 text-gray-700",
                                attrs: { for: "anticipatedDD" }
                              },
                              [_vm._v("Anticipated Delivery Date")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "mt-1 relative rounded-md shadow-sm"
                              },
                              [
                                _c("date-picker", {
                                  attrs: {
                                    "value-type": "YYYY-MM-DD",
                                    format: "MM/DD/YYYY",
                                    name: "anticipatedDD",
                                    disabled: _vm.isDisabled
                                  },
                                  model: {
                                    value: _vm.ao.anticipatedDD,
                                    callback: function($$v) {
                                      _vm.$set(_vm.ao, "anticipatedDD", $$v)
                                    },
                                    expression: "ao.anticipatedDD"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "w-1/2 p-2" }, [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "block text-sm font-medium leading-5 text-gray-700",
                                attrs: { for: "actualDD" }
                              },
                              [_vm._v("Actual Delivery Date")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "mt-1 relative rounded-md shadow-sm"
                              },
                              [
                                _c("date-picker", {
                                  attrs: {
                                    "value-type": "YYYY-MM-DD",
                                    format: "MM/DD/YYYY",
                                    name: "actualDD",
                                    disabled: _vm.isDisabled
                                  },
                                  model: {
                                    value: _vm.ao.actualDD,
                                    callback: function($$v) {
                                      _vm.$set(_vm.ao, "actualDD", $$v)
                                    },
                                    expression: "ao.actualDD"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "w-1/2 p-2" }, [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "block text-sm font-medium leading-5 text-gray-700",
                                attrs: { for: "bol" }
                              },
                              [_vm._v("BOL Number")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "mt-1 relative rounded-md shadow-sm"
                              },
                              [
                                _c("input", {
                                  staticClass:
                                    "form-input block w-full sm:text-sm sm:leading-5",
                                  attrs: {
                                    type: "text",
                                    name: "bol",
                                    disabled: _vm.isDisabled
                                  },
                                  domProps: { value: _vm.order.shipping.bol },
                                  on: { change: _vm.inputValueChanged }
                                })
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "w-1/2 p-2 hidden" }, [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "block text-sm font-medium leading-5 text-gray-700",
                                attrs: { for: "chr" }
                              },
                              [_vm._v("CHR Number")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "mt-1 relative rounded-md shadow-sm"
                              },
                              [
                                _c("input", {
                                  staticClass:
                                    "form-input block w-full sm:text-sm sm:leading-5",
                                  attrs: {
                                    type: "text",
                                    name: "chr",
                                    disabled: _vm.isDisabled
                                  },
                                  domProps: { value: _vm.order.shipping.chr },
                                  on: { change: _vm.inputValueChanged }
                                })
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "w-full p-2" }, [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "block text-sm font-medium leading-5 text-gray-700 mb-2",
                                attrs: { for: "notes" }
                              },
                              [_vm._v("Notes")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "max-w-lg flex rounded-md shadow-sm"
                              },
                              [
                                _c("editor", {
                                  attrs: {
                                    "api-key":
                                      "skv2keu22mkkh9x439gwsx3neyd7hd023ff8m5iofqifchs4",
                                    init: {
                                      height: 300,
                                      menubar: false,
                                      plugins: [
                                        "advlist autolink lists link image charmap print preview anchor",
                                        "insertdatetime media table paste code help wordcount"
                                      ],
                                      toolbar:
                                        "undo redo | formatselect | bold italic backcolor | \
                            alignleft aligncenter alignright alignjustify | \
                            bullist numlist outdent indent | removeformat | help"
                                    },
                                    disabled: _vm.isDisabled
                                  },
                                  model: {
                                    value: _vm.orderShippingNotes,
                                    callback: function($$v) {
                                      _vm.orderShippingNotes = $$v
                                    },
                                    expression: "orderShippingNotes"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ]
                      )
                    ])
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "shadow-sm p-4", attrs: { id: "delivery" } },
              [
                _c("div", { staticClass: "md:grid md:grid-cols-3 md:gap-6" }, [
                  _vm._m(3),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-5 md:mt-0 md:col-span-2" }, [
                    _c("div", { staticClass: "shadow sm:rounded-md" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "px-4 py-5 bg-white sm:p-6 flex flex-wrap"
                        },
                        [
                          _c("div", { staticClass: "w-1/3 p-2" }, [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "block text-sm font-medium leading-5 text-gray-700",
                                attrs: { for: "receivingContactName" }
                              },
                              [_vm._v("Receiving Contact Name")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "mt-1 relative rounded-md shadow-sm"
                              },
                              [
                                _c("input", {
                                  staticClass:
                                    "form-input block w-full sm:text-sm sm:leading-5",
                                  attrs: {
                                    type: "text",
                                    name: "receivingContactName"
                                  },
                                  domProps: {
                                    value: _vm.ao.receivingContactName
                                  },
                                  on: { change: _vm.inputValueChanged }
                                })
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "w-1/3 p-2" }, [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "block text-sm font-medium leading-5 text-gray-700",
                                attrs: { for: "receivingContactEmail" }
                              },
                              [_vm._v("Receiving Contact Email")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "mt-1 relative rounded-md shadow-sm"
                              },
                              [
                                _c("input", {
                                  staticClass:
                                    "form-input block w-full sm:text-sm sm:leading-5",
                                  attrs: {
                                    type: "text",
                                    name: "receivingContactEmail"
                                  },
                                  domProps: {
                                    value: _vm.ao.receivingContactEmail
                                  },
                                  on: { change: _vm.inputValueChanged }
                                })
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "w-1/3 p-2" }, [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "block text-sm font-medium leading-5 text-gray-700",
                                attrs: { for: "receivingContactPhone" }
                              },
                              [_vm._v("Receiving Contact Phone")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "mt-1 relative rounded-md shadow-sm"
                              },
                              [
                                _c("input", {
                                  staticClass:
                                    "form-input block w-full sm:text-sm sm:leading-5",
                                  attrs: {
                                    type: "text",
                                    name: "receivingContactPhone"
                                  },
                                  domProps: {
                                    value: _vm.ao.receivingContactPhone
                                  },
                                  on: { change: _vm.inputValueChanged }
                                })
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "w-4/12 p-2" }, [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "block text-sm font-medium leading-5 text-gray-700",
                                attrs: { for: "webPortal" }
                              },
                              [_vm._v("Web Portal")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "mt-1 relative rounded-md shadow-sm"
                              },
                              [
                                _c("input", {
                                  staticClass:
                                    "form-input block w-full sm:text-sm sm:leading-5",
                                  attrs: { type: "text", name: "webPortal" },
                                  domProps: { value: _vm.ao.webPortal },
                                  on: { change: _vm.inputValueChanged }
                                })
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "w-4/12 p-2" }, [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "block text-sm font-medium leading-5 text-gray-700",
                                attrs: { for: "deliveryWindow" }
                              },
                              [_vm._v("Delivery Window")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "mt-1 relative rounded-md shadow-sm"
                              },
                              [
                                _c("input", {
                                  staticClass:
                                    "form-input block w-full sm:text-sm sm:leading-5",
                                  attrs: {
                                    type: "text",
                                    name: "deliveryWindow"
                                  },
                                  domProps: { value: _vm.ao.deliveryWindow },
                                  on: { change: _vm.inputValueChanged }
                                })
                              ]
                            )
                          ])
                        ]
                      )
                    ])
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "shadow-sm p-4", attrs: { id: "po" } },
              [
                _c("div", { staticClass: "md:grid md:grid-cols-3 md:gap-6" }, [
                  _vm._m(4),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-5 md:mt-0 md:col-span-2" }, [
                    _c("div", { staticClass: "shadow sm:rounded-md" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "px-4 py-5 bg-white sm:p-6 flex flex-wrap"
                        },
                        [
                          _c("div", { staticClass: "w-2/12 p-2" }, [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "block text-sm font-medium leading-5 text-gray-700 mb-2",
                                attrs: { for: "poRequired" }
                              },
                              [_vm._v("Is a PO Number Required?")]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              attrs: {
                                id: "poRequired",
                                name: "poRequired",
                                type: "checkbox"
                              },
                              domProps: { checked: _vm.ao.poRequired },
                              on: { click: _vm.checkboxValueChanged }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "w-4/12 p-2" }, [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "block text-sm font-medium leading-5 text-gray-700",
                                attrs: { for: "poNum" }
                              },
                              [_vm._v("PO Number")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "mt-1 relative rounded-md shadow-sm"
                              },
                              [
                                _c("input", {
                                  staticClass:
                                    "form-input block w-full sm:text-sm sm:leading-5",
                                  attrs: { type: "text", name: "poNum" },
                                  domProps: { value: _vm.ao.poNum },
                                  on: { change: _vm.inputValueChanged }
                                })
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "w-4/12 p-2" }, [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "block text-sm font-medium leading-5 text-gray-700",
                                attrs: { for: "poDate" }
                              },
                              [_vm._v("PO Date for Delivery")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "mt-1 relative rounded-md shadow-sm"
                              },
                              [
                                _c("date-picker", {
                                  attrs: {
                                    "value-type": "YYYY-MM-DD",
                                    format: "MM/DD/YYYY",
                                    name: "poDate"
                                  },
                                  model: {
                                    value: _vm.ao.poDate,
                                    callback: function($$v) {
                                      _vm.$set(_vm.ao, "poDate", $$v)
                                    },
                                    expression: "ao.poDate"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ]
                      )
                    ])
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "section",
              {
                staticClass: "shadow-sm p-4",
                attrs: { id: "order-instructions" }
              },
              [
                _c("div", { staticClass: "md:grid md:grid-cols-3 md:gap-6" }, [
                  _vm._m(5),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-5 md:mt-0 md:col-span-2" }, [
                    _c(
                      "div",
                      {
                        staticClass: "shadow sm:rounded-md sm:overflow-hidden"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "px-4 py-5 bg-white sm:p-6 flex flex-wrap"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "w-full p-2 flex rounded-md shadow-sm"
                              },
                              [
                                _c("editor", {
                                  attrs: {
                                    "api-key":
                                      "skv2keu22mkkh9x439gwsx3neyd7hd023ff8m5iofqifchs4",
                                    init: {
                                      height: 300,
                                      menubar: false,
                                      plugins: [
                                        "advlist autolink lists link image charmap print preview anchor",
                                        "insertdatetime media table paste code help wordcount"
                                      ],
                                      toolbar:
                                        "undo redo | formatselect | bold italic backcolor | \
                          alignleft aligncenter alignright alignjustify | \
                          bullist numlist outdent indent | removeformat | help"
                                    }
                                  },
                                  model: {
                                    value: _vm.ao.specialInstructions,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.ao,
                                        "specialInstructions",
                                        $$v
                                      )
                                    },
                                    expression: "ao.specialInstructions"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      ]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "shadow-sm p-4", attrs: { id: "items" } },
              [
                _c("div", { staticClass: "md:grid md:grid-cols-3 md:gap-6" }, [
                  _vm._m(6),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-5 md:mt-0 md:col-span-2" }, [
                    _c(
                      "table",
                      { staticClass: "min-w-full divide-y divide-grey" },
                      [
                        _vm._m(7),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(_vm.order.items, function(item, index) {
                            return _c(
                              "tr",
                              { key: index, staticClass: "bg-white" },
                              [
                                _c("td", {
                                  staticClass:
                                    "px-6 py-4 whitespace text-sm leading-5 font-medium text-gray-900",
                                  domProps: { innerHTML: _vm._s(item.title) }
                                }),
                                _vm._v(" "),
                                _c("td", {
                                  staticClass:
                                    "px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-500",
                                  domProps: { innerHTML: _vm._s(item.qty) }
                                })
                              ]
                            )
                          }),
                          0
                        )
                      ]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "section",
              {
                staticClass: "rounded-md shadown-sm p-4 flex justify-end",
                attrs: { id: "actions" }
              },
              [
                _c(
                  "button",
                  {
                    staticClass:
                      "rounded-full flex items-center text-base text-white shadow-solid bg-green py-2 px-4 mt-4",
                    attrs: { type: "submit", disabled: _vm.submitting },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.submit($event)
                      }
                    }
                  },
                  [_vm._v("Save")]
                )
              ]
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "md:col-span-1" }, [
      _c("div", { staticClass: "px-4 sm:px-0" }, [
        _c("h2", { staticClass: "header text-xl text-green" }, [
          _vm._v("Order Information")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "md:col-span-1" }, [
      _c("div", { staticClass: "px-4 sm:px-0" }, [
        _c("h2", { staticClass: "header text-xl text-green" }, [
          _vm._v("Buyer's Information")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "md:col-span-1" }, [
      _c("div", { staticClass: "px-4 sm:px-0" }, [
        _c("h2", { staticClass: "header text-xl text-green" }, [
          _vm._v("Shipping Information")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "md:col-span-1" }, [
      _c("div", { staticClass: "px-4 sm:px-0" }, [
        _c("h2", { staticClass: "header text-xl text-green" }, [
          _vm._v("Delivery Information")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "md:col-span-1" }, [
      _c("div", { staticClass: "px-4 sm:px-0" }, [
        _c("h2", { staticClass: "header text-xl text-green" }, [
          _vm._v("Purchase Order")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "md:col-span-1" }, [
      _c("div", { staticClass: "px-4 sm:px-0" }, [
        _c("h2", { staticClass: "header text-xl text-green" }, [
          _vm._v("Special Instructions")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "md:col-span-1" }, [
      _c("div", { staticClass: "px-4 sm:px-0" }, [
        _c("h2", { staticClass: "header text-xl text-green" }, [
          _vm._v("Ordered Kits")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c(
          "th",
          {
            staticClass:
              "px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
          },
          [_vm._v("\n                      Name\n                    ")]
        ),
        _vm._v(" "),
        _c(
          "th",
          {
            staticClass:
              "px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
          },
          [_vm._v("\n                      Quantity\n                    ")]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }